import React, { useCallback } from 'react';
import { ServicesContext } from '../ServicesContext';

type GetGapFn = (gapId: number, gapType: number) => Promise<void>;

export const useDeleteSubmissionAnswer = (getGap: GetGapFn) => {
    const services = React.useContext(ServicesContext);

    const deleteSubmissionAnswer = useCallback(
        async (gapType: number, gapId: number, submissionAnswerId: number) => {
            await services.api.call({
                method: 'delete',
                url: `/api/submission-answers/${submissionAnswerId}`,
            });

            await getGap(gapId, gapType);
        },
        [services.api, getGap]
    );

    return deleteSubmissionAnswer;
};
